import { render, staticRenderFns } from "./SummaryBeforeCloseShop.vue?vue&type=template&id=e54e4490&scoped=true"
import script from "./SummaryBeforeCloseShop.vue?vue&type=script&lang=js"
export * from "./SummaryBeforeCloseShop.vue?vue&type=script&lang=js"
import style0 from "./SummaryBeforeCloseShop.vue?vue&type=style&index=0&id=e54e4490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54e4490",
  null
  
)

export default component.exports